import { cookieRef } from '@layouts/stores/config'
import type { Modules } from '@/types/generated'

export interface TableOptions {
  page: number
  perPage: number
  sortBy: string
  status?: string
  search?: string
  scenario?: string
  tour?: string
  tourIds?: [string] | string[]
  orderBy?: boolean | 'asc' | 'desc'
  role?: string | null
  activity?: string | null
  activityFrom?: string | null
  customFieldId?: string | null
  customFieldOptionId?: string | null
  lastLogin?: Modules.User.Enums.LastLoginFilterEnum | null
  lastLoginFrom?: string | null
}

// SECTION Store
export const useUserStore = defineStore('user', () => {
  const responseHasError = ref<boolean>(false)
  const notAuthorized = ref<boolean>(false)
  const forbidden = ref<boolean>(false)
  const chatUnreadCount = ref<number>(0)
  const chatNewMessage = ref<boolean>(false)
  const newNotification = ref<boolean>(false)
  const shouldUpdateGameList = ref<boolean>(false)
  const shouldUpdateGameEvaluation = ref<boolean>(false)
  const shouldUpdateGameComments = ref<boolean>(false)
  const shouldUpdateProtocolPopup = ref<boolean>(false)
  const shouldUpdateSCORMList = ref<boolean>(false)
  const newGameSchedulingTime = ref<string>('')
  const chatNewMessageText = ref<string>('')
  const newNotificationText = ref<string>('')
  const chatNewMessageFrom = ref<string>('')
  const chatLogPS = ref()
  const maintenanceNotification = ref<boolean>(false)
  const maintenanceNotificationText = ref<string>('')
  const meetingsAvailable = ref<boolean>(true)
  const hasAvatar = cookieRef('avatar', false)
  const fullName = cookieRef('fullName', '')

  return {
    responseHasError,
    forbidden,
    chatUnreadCount,
    newNotification,
    newNotificationText,
    chatNewMessage,
    chatNewMessageText,
    shouldUpdateGameList,
    shouldUpdateGameEvaluation,
    shouldUpdateGameComments,
    shouldUpdateProtocolPopup,
    shouldUpdateSCORMList,
    newGameSchedulingTime,
    chatNewMessageFrom,
    chatLogPS,
    maintenanceNotification,
    maintenanceNotificationText,
    meetingsAvailable,
    hasAvatar,
    notAuthorized,
    fullName,
  }
})
